import {handleLogout} from "components/utils"; import React, {useEffect, useState} from 'react';
import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions,
    TableBody,
    TableColumnType,
    TableHeader
} from "react-bs-datatable";
import {Button, Col, Form, Modal, OverlayTrigger, Row, Tab, Table, Tabs, Tooltip} from "react-bootstrap";
import axios from "axios";
import {useCookies} from "react-cookie";
import {hasInternalPermissions, INVENTORY} from "../../permissions";
import {InsuranceRateItemView} from "./InsuranceRateItemView";

export const InsuranceRateItemsView = (props: { itemId: string, cookieEntityQr: any}) => {

    const [items, setItems] = useState<Array<string>>([]);

    const [cookies] = useCookies(['qme']);

    const [insurances, setInsurances] = useState<Array<any>>([]);

    function fetchInsurances() {
        axios.get('/api/backend/ipd/insurance/provider/fetch/all/' + props.cookieEntityQr)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                if (resp.data) {
                    setInsurances(resp.data)
                }
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    useEffect(() => {
        fetchInsurances()
    }, [props.cookieEntityQr])

    useEffect(() => {
        fetchItems()
    }, [props.itemId])

    function fetchItems() {
        axios.get('/api/backend/inventory/item/batch/fetch/all/' + props.itemId)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setItems(resp.data)
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    const handlePostAction = () => {
        setShowItemModal(false)
        fetchItems()
    };

    const [skuItem, setSkuItem] = useState<any>();
    const [showItemModal, setShowItemModal] = useState(false);
    const handleRemoveItemModal = () => setShowItemModal(false);
    const handleShowItemModal = (item) => {
        setSkuItem(item)
        setShowItemModal(true)
    }

    function getModalForItem() {
        return <Modal
            show={showItemModal}
            onHide={handleRemoveItemModal}
            backdrop="static"
            className="modal-xl"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                <InsuranceRateItemView  insurances={insurances} skuItem={{...skuItem, itemId: props.itemId}}  postAction={handlePostAction}/>
            </Modal.Body>
        </Modal>;
    }

    useEffect(() => {
        fetchItems();
    }, [])

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Item is running low in quantity
        </Tooltip>
    );
    const ITEMS_HEADERS: TableColumnType<any>[] = [
        {
            prop: "sku",
            title: "Sponsor",
            cell: (row) => (
                <><a href="#/" className="text-primary text-decoration-none"
                     onClick={e => handleShowItemModal(row)}><img
                    height="14rem" width="14rem" src="/external-link.png" alt="external-link-icon"
                    className="align-self-center"/>&nbsp;&nbsp;{
                    row.sku == "none" ? "Self" : insurances && insurances.filter(insurance => insurance.id == row.sku)[0]?.tpa
                }</a>
                </>
            )
        },
        {
            prop: "sellingPrice",
            title: "Cost (inclusive of Taxes)"
        }
    ];

    function getItemsTable() {
        return <div className="overflow-scroll"><DatatableWrapper
            body={items}
            headers={ITEMS_HEADERS}
            paginationOptionsProps={{
                initialState: {
                    rowsPerPage: 30,
                    options: [30, 50, 100]
                }
            }}
        >
            <Table>
                <TableHeader/>
                <TableBody/>
            </Table>
            <Row className="mt-4 p-2">
                <Col
                    xs={12}
                    sm={12}
                    lg={12}
                    className="d-flex flex-col justify-content-end align-items-end"
                >
                    <Pagination/>
                </Col>
            </Row>
        </DatatableWrapper>
        </div>;
    }

    return (
        <>
            <div className="row my-5">
                <div className="col">
                    <div className="card p-2 shadow-sm">
                        <div className="d-flex justify-content-between py-2 pr-2">
                            <h5 className="text-primary pl-1">Rate Card</h5>
                            <div>
                                {hasInternalPermissions(cookies.qme, INVENTORY) && <>
                                    <Button className="btn btn-warning btn-sm text-white"
                                            onClick={e => handleShowItemModal(null)}
                                    >
                                        + Add Rate
                                    </Button>&nbsp;</>}
                            </div>
                        </div>
                        {getItemsTable()}
                        {getModalForItem()}
                    </div>
                </div>
            </div>
        </>
    );
};
